export const EXTENSION_NAME = "bitec-buri"
